<script>
import AssignAsTeacher from "./AssignAsTeacher.svelte";
import AddStudentsToTeacher from "./AddStudentsToTeacher.svelte";

const options = [
    { color: 'AssignAsTeacher',   component: AssignAsTeacher   },
    { color: 'AddStudentsToTeacher', component: AddStudentsToTeacher }//,
    // { color: 'синий',  component: AssignAsTeacher  },
];

let selected = options[1];


</script>

<style>
  ul#menu {
    display: inline;
    padding: 0px !important;
    /* border: #ff3e00; */
    /* border-style: dashed; */
  }

  ul#menu li {
    display: inline;
  }

  ul#menu li .active {
    font-weight: bold;
  }

</style>

<!-- <select bind:value={selected}>
	{#each options as option}
		<option value={option}>{option.color}</option>
	{/each}
</select> -->
<ul id="menu">
    {#each options as option, i}
    <li >
        <a
            href="/"
            on:click|preventDefault={() => selected = option}
            class:active={selected === option}>
            {option.color}
        </a> 
        {#if i != options.length - 1} | {/if}
    </li>
	{/each}
</ul>

<svelte:component this={selected.component}/>